import React, { memo, useEffect, useState } from "react";
import { Sidebar } from "./sidebar";
import { Header } from "./Header";
import { useLocation } from "react-router-dom";

interface Props {
  children: JSX.Element | JSX.Element[];
  collapsed?: boolean;
  onCollapse?: () => void;
}

export const AdminLayout = memo((props: Props) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header takes full width at the top */}
      <Header />

      {/* Main layout with Sidebar and Content */}
      <div className="flex flex-1 relative">
        <Sidebar className="w-[260px] bg-white border-r border-gray-100 flex-shrink-0" />
        <main className="flex-1 p-8 overflow-auto">
          <div className="max-w-7xl mx-auto">
            {props.children}
          </div>
        </main>
      </div>
    </div>
  );
});
